import { Flex } from "Element/Flex";
import styled from "styled-components";

export const MintingWrapper = styled(Flex)`
  margin: 80px 120px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 64px 24px;
  `}
`;

export const MintFooterWrapper = styled(Flex)`
  > button {
    padding: 6px 36px 4px;
  }
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `}
`;

export const MintInfo = styled.span`
  ${({ theme }) => theme.fontStyle.primary};
  color: ${({ theme }) => theme.colors.neutral60};
  margin-bottom: 24px;
  text-align: center;
`;
